<span class="customer-main-contact" *ngIf="(contactRef$  | async) != null">
  <app-contact-view [ref]="contactRef$ | async"
                    [hidden]="(contactRef$ | async) == null"
  ></app-contact-view>
</span>
